export default __webpack_public_path__ + "static/media/servicesGroom.193e6a36.jpg";